import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BettingComponent } from './betting.component';

const routes: Routes = [
  {
    path: 'betting',
    component: BettingComponent
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BettingRoutingModule {
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/betting/betting-routing.module.ts